import classNames from 'classnames';
import React from 'react';
import styles from './Container.module.scss';
export const Container = ({ children, className = '', fluid = false, bleed = false, }) => {
    const containerClassNames = classNames(styles.blHavenContainer, className, {
        [styles.blHavenContainerBleed]: bleed,
        [styles.blHavenContainerFluid]: fluid,
    });
    return (<>
      <div className={containerClassNames}>{children}</div>
    </>);
};
